import axios from 'axios';

const configuredBase = process.env.REACT_APP_API_BASE_URL?.trim();
const API_BASE = (configuredBase || '/api').replace(/\/+$/, '');

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
}

// Restore on module load if present
const initToken = typeof window !== 'undefined' && localStorage.getItem('fpccs_token');
if (initToken) setAuthToken(initToken);

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Auto logout if token invalid
      localStorage.removeItem('fpccs_token');
      localStorage.removeItem('fpccs_user');
      if (typeof window !== 'undefined' && !['/login', '/install'].includes(window.location.pathname)) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export { API_BASE };
export default api;
